
import { sortBy } from 'lodash-es'
import transactionsApi from '@/modules/transactions/_api'
export default {
  data () {
    return {
      budgetTagTypes: [],
      isFetchingBudgetTagTypes: false,
      selectedBudgetMandatoryTagTypes: [],
      selectedBudgetNoMandatoryTagTypes: [],
      recentTagTypes: []
    }
  },
  computed: {
    loggedUserId () {
      return this.$store.getters['LoginStore/loggedUserId']
    }
  },
  methods: {
    setBudget (budget, type) {
      this.setField('budget', budget)
      this.getBudgetTagTypes(type)
    },
    async getBudgetTagTypes (transactionType = 'TRANSACTION') {
      if (this.isFetchingBudgetTagTypes || !this.budget?.id) return
      try {
        this.isFetchingBudgetTagTypes = true
        const filters = {
          'budget.id': this.budget.id,
          'tagType.includeInTransactionTypes': transactionType
        }
        const response = await transactionsApi.getBudgetTagTypes(filters)

        this.budgetTagTypes = response.data
        this.selectedBudgetNoMandatoryTagTypes = sortBy(this.budgetTagTypes?.filter((el) => !el.mandatory), el => el.id)
        this.selectedBudgetMandatoryTagTypes = sortBy(this.budgetTagTypes?.filter((el) => el.mandatory), el => el.id)
        this.checkTagTypes()
        this.autoFillTagType()
        await this.fetchRecentTagTypes()
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transactions_fetch_budget_custom_field_error' })
      } finally {
        this.isFetchingBudgetTagTypes = false
      }
    },
    async fetchRecentTagTypes () {
      let userId = this.transaction?.card?.user?.id ?? this.loggedUserId

      for (let budgetTagType of this.budgetTagTypes) {
        const response = await transactionsApi.getRecentTagTypes(userId, budgetTagType.tagType.id)
        if (budgetTagType.tagType.tags.length >= 10) {
          budgetTagType.tagType.tags.unshift(...this._initializeRecentOptions(response.data))
        }
        budgetTagType.tagType.tags = budgetTagType.tagType.tags.map(el => {
          if (!el.optionType) {
            return { ...el, optionType: 'OPTION' }
          } else {
            return { ...el }
          }
        })
      }
    },
    handleCreateTagPlaceholder (customOptionsEnabled) {
      if (customOptionsEnabled) {
        return 'company_create_transaction_field_option_tag_transaction_detail_placeholder'
      }
      return ''
    },
    _initializeRecentOptions (recentFields) {
      const tagList = []

      if (recentFields.length) {
        tagList.push({
          id: 'RECENTS',
          name: this.$i18n.t('MULTISELECT_OPTION_LABEL_RECENT'),
          $isDisabled: true,
          optionType: 'TITLE'

        })
        tagList.push(...recentFields)
        tagList.push({
          id: 'SEPARATOR',
          optionType: 'SEPARATOR',
          name: 'SEPARATOR',
          $isDisabled: true
        })
        tagList.push({
          id: 'ALL',
          name: this.$i18n.t('MULTISELECT_OPTION_LABEL_ALL'),
          $isDisabled: true,
          optionType: 'TITLE'
        })
      }

      return tagList
    },

    handleCustomFieldIsRequired (customField) {
      if (customField.require === 'NEVER' || customField.requireBudgets.length === 0) return false
      return customField.requireBudgets.find(el => el.id === this.selectedBudget.id) !== 'undefined'
    },
    handleCustomFieldValues (customField) {
      if (this.transactionTags.length === 0) return
      let { id } = customField
      let customFieldValues = []
      this.transactionTags.forEach(el => {
        if (el && el.tag.type.id === id) {
          customFieldValues.push(el.tag)
        }
      })

      return customFieldValues
    },
    addTagToTransactionTag (field, event) {
      let transactionTag = {
        tag: {
          id: event.id,
          name: event.name,
          type: {
            id: field.tagType.id
          }
        }
      }
      const tagIndex = this.budgetTagTypes?.findIndex(el => el.tagType.id === field.tagType.id)
      const tag = this.budgetTagTypes[tagIndex]
      if (tag.tagType.multipleOptionsEnabled) {
        const tagExists = this.transactionTags.findIndex(el => el.tag.id === transactionTag.tag.id)
        if (tagExists >= 0) return
        this.transactionTags.push(transactionTag)
        this.transactionTagUpdatedFlag = true
      } else {
        const index = this.transactionTags.findIndex(el => el.tag.type.id === transactionTag.tag.type.id)
        if (index >= 0) {
          this.transactionTags.splice(index, 1, transactionTag)
        } else {
          this.transactionTags.push(transactionTag)
        }
        this.transactionTagUpdatedFlag = true
      }
      const budgetTagTypesIndex = this.budgetTagTypes.findIndex(item => item.tagType.id === field.tagType.id)
      this.budgetTagTypes.splice(budgetTagTypesIndex, 1, { ...this.budgetTagTypes[budgetTagTypesIndex], filled: true })
    },

    removeTagFromTransactionTag (event) {
      let index = []
      this.transactionTags = [...this.transactionTags.filter(el => {
        if (event.tagToRemove.id) {
          return el.tag.id !== event.tagToRemove.id
        } else {
          return el.tag.name !== event.tagToRemove.name
        }
      })]
      this.transactionTags.forEach(item => {
        index.push(item.tag?.type?.id)
      })
      this.budgetTagTypes.forEach(item => {
        if (!index.includes(item.tagType.id)) {
          item.filled = false
        }
      })
    },

    async handleCreateOption (customField, event) {
      const newTag = {
        name: event.name,
        id: `_${Math.random().toString(36).substr(2, 6)}`, // Generates local id to prevent conflicts
        type: {
          id: customField.id
        }
      }
      this.addTagToTransactionTag(customField, newTag)
    },
    checkTagTypes () {
      if (this.transaction?.id) {
        this.transaction.transactionTags.forEach(transactionTag => {
          this.budgetTagTypes.forEach(item => {
            if (transactionTag.tag.type.id === item.tagType.id) {
              item.filled = true
            }
          })
        })
      }
    },
    autoFillTagType () {
      this.selectedBudgetMandatoryTagTypes.forEach(el => {
        if (el.tagType?.tags.length === 1 && !el.tagType?.customOptionEnabled) {
          this.addTagToTransactionTag(el, el.tagType.tags[0])
        }
      })
      this.selectedBudgetNoMandatoryTagTypes.forEach(el => {
        if (el.tagType?.tags.length === 1 && !el.tagType?.customOptionEnabled) {
          this.addTagToTransactionTag(el, el.tagType.tags[0])
        }
      })
      this.checkTagTypes()
    }
  },

  watch: {
    selectedBudget: function (newV, oldV) {
      if (newV && newV.budgetTagTypes) {
        this.selectedBudgetNoMandatoryTagTypes = sortBy(newV.budgetTagTypes?.filter((el) => !el.mandatory), el => el.id)
        this.selectedBudgetMandatoryTagTypes = sortBy(newV.budgetTagTypes?.filter((el) => el.mandatory), el => el.id)

        this.autoFillTagType()
      }
    }
  }
}
